var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignsPlanetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7493 1.91768C30.8263 -1.31836 43.24 5.84869 46.476 17.9257C49.7121 30.0028 42.545 42.4165 30.468 45.6525C18.3909 48.8885 5.97724 41.7215 2.74121 29.6444C-0.494823 17.5674 6.67223 5.15371 18.7493 1.91768ZM30.2819 44.9581C41.9754 41.8248 48.9149 29.8053 45.7816 18.1118C42.6483 6.41827 30.6289 -0.521184 18.9353 2.61209C7.2418 5.74536 0.302348 17.7649 3.43562 29.4584C6.56889 41.1519 18.5884 48.0914 30.2819 44.9581Z",
    fill: "url(#paint0_radial_2429_487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2653 15.3313C5.2653 16.2809 4.4955 17.0507 3.5459 17.0507C2.5963 17.0507 1.8265 16.2809 1.8265 15.3313C1.8265 14.3817 2.5963 13.6119 3.5459 13.6119C4.4955 13.6119 5.2653 14.3817 5.2653 15.3313Z",
    fill: "url(#paint1_radial_2429_487)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55187 32.7403C5.55187 33.7295 4.74999 34.5313 3.76083 34.5313C2.77166 34.5313 1.96978 33.7295 1.96978 32.7403C1.96978 31.7511 2.77166 30.9493 3.76083 30.9493C4.74999 30.9493 5.55187 31.7511 5.55187 32.7403Z",
    fill: "url(#paint2_radial_2429_487)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0026 41.7672C13.0026 42.8355 12.1366 43.7015 11.0683 43.7015C9.99999 43.7015 9.13396 42.8355 9.13396 41.7672C9.13396 40.6989 9.99999 39.8328 11.0683 39.8328C12.1366 39.8328 13.0026 40.6989 13.0026 41.7672Z",
    fill: "url(#paint3_radial_2429_487)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4713 46.0657C26.4713 47.134 25.6052 48 24.5369 48C23.4686 48 22.6026 47.134 22.6026 46.0657C22.6026 44.9974 23.4686 44.1313 24.5369 44.1313C25.6052 44.1313 26.4713 44.9974 26.4713 46.0657Z",
    fill: "url(#paint4_radial_2429_487)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9399 41.7672C39.9399 42.8355 39.0739 43.7015 38.0056 43.7015C36.9373 43.7015 36.0713 42.8355 36.0713 41.7672C36.0713 40.6989 36.9373 39.8328 38.0056 39.8328C39.0739 39.8328 39.9399 40.6989 39.9399 41.7672Z",
    fill: "url(#paint5_radial_2429_487)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.534 32.7403C47.534 33.8086 46.6679 34.6746 45.5996 34.6746C44.5313 34.6746 43.6653 33.8086 43.6653 32.7403C43.6653 31.672 44.5313 30.806 45.5996 30.806C46.6679 30.806 47.534 31.672 47.534 32.7403Z",
    fill: "url(#paint6_radial_2429_487)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7161 5.80299C12.7161 6.71302 11.9783 7.45075 11.0683 7.45075C10.1583 7.45075 9.42053 6.71302 9.42053 5.80299C9.42053 4.89295 10.1583 4.15522 11.0683 4.15522C11.9783 4.15522 12.7161 4.89295 12.7161 5.80299Z",
    fill: "url(#paint7_radial_2429_487)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.328 1.7194C26.328 2.669 25.5582 3.43881 24.6086 3.43881C23.659 3.43881 22.8892 2.669 22.8892 1.7194C22.8892 0.769803 23.659 0 24.6086 0C25.5582 0 26.328 0.769803 26.328 1.7194Z",
    fill: "url(#paint8_radial_2429_487)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4534 10.3164C20.4534 11.1078 19.8119 11.7493 19.0205 11.7493C18.2292 11.7493 17.5877 11.1078 17.5877 10.3164C17.5877 9.52508 18.2292 8.88358 19.0205 8.88358C19.8119 8.88358 20.4534 9.52508 20.4534 10.3164Z",
    fill: "url(#paint9_radial_2429_487)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4534 36.1075C20.4534 36.8988 19.8119 37.5403 19.0205 37.5403C18.2292 37.5403 17.5877 36.8988 17.5877 36.1075C17.5877 35.3161 18.2292 34.6746 19.0205 34.6746C19.8119 34.6746 20.4534 35.3161 20.4534 36.1075Z",
    fill: "url(#paint10_radial_2429_487)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0116 31.3791C16.0116 32.1704 15.3701 32.8119 14.5787 32.8119C13.7874 32.8119 13.1459 32.1704 13.1459 31.3791C13.1459 30.5878 13.7874 29.9463 14.5787 29.9463C15.3701 29.9463 16.0116 30.5878 16.0116 31.3791Z",
    fill: "url(#paint11_radial_2429_487)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4862 10.3881C31.4862 11.1398 30.8768 11.7493 30.125 11.7493C29.3732 11.7493 28.7638 11.1398 28.7638 10.3881C28.7638 9.63629 29.3732 9.02687 30.125 9.02687C30.8768 9.02687 31.4862 9.63629 31.4862 10.3881Z",
    fill: "url(#paint12_radial_2429_487)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0713 15.403C36.0713 16.1548 35.4618 16.7642 34.7101 16.7642C33.9583 16.7642 33.3489 16.1548 33.3489 15.403C33.3489 14.6512 33.9583 14.0418 34.7101 14.0418C35.4618 14.0418 36.0713 14.6512 36.0713 15.403Z",
    fill: "url(#paint13_radial_2429_487)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4862 36.1791C31.4862 36.9309 30.8768 37.5403 30.125 37.5403C29.3732 37.5403 28.7638 36.9309 28.7638 36.1791C28.7638 35.4273 29.3732 34.8179 30.125 34.8179C30.8768 34.8179 31.4862 35.4273 31.4862 36.1791Z",
    fill: "url(#paint14_radial_2429_487)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0713 31.4507C36.0713 32.2025 35.4618 32.8119 34.7101 32.8119C33.9583 32.8119 33.3489 32.2025 33.3489 31.4507C33.3489 30.699 33.9583 30.0896 34.7101 30.0896C35.4618 30.0896 36.0713 30.699 36.0713 31.4507Z",
    fill: "url(#paint15_radial_2429_487)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0862 23.6418C41.0862 24.5123 40.3806 25.2179 39.5101 25.2179C38.6396 25.2179 37.934 24.5123 37.934 23.6418C37.934 22.7713 38.6396 22.0657 39.5101 22.0657C40.3806 22.0657 41.0862 22.7713 41.0862 23.6418Z",
    fill: "url(#paint16_radial_2429_487)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4683 10.3881C25.4683 10.9024 25.0513 11.3194 24.5369 11.3194C24.0226 11.3194 23.6056 10.9024 23.6056 10.3881C23.6056 9.87369 24.0226 9.45672 24.5369 9.45672C25.0513 9.45672 25.4683 9.87369 25.4683 10.3881Z",
    fill: "url(#paint17_radial_2429_487)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9549 20.7045C44.9549 21.1397 44.602 21.4925 44.1668 21.4925C43.7316 21.4925 43.3787 21.1397 43.3787 20.7045C43.3787 20.2692 43.7316 19.9164 44.1668 19.9164C44.602 19.9164 44.9549 20.2692 44.9549 20.7045Z",
    fill: "url(#paint18_radial_2429_487)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.525 23.5701C44.525 24.0054 44.1722 24.3582 43.7369 24.3582C43.3017 24.3582 42.9489 24.0054 42.9489 23.5701C42.9489 23.1349 43.3017 22.7821 43.7369 22.7821C44.1722 22.7821 44.525 23.1349 44.525 23.5701Z",
    fill: "url(#paint19_radial_2429_487)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9549 26.7224C44.9549 27.1576 44.602 27.5104 44.1668 27.5104C43.7316 27.5104 43.3787 27.1576 43.3787 26.7224C43.3787 26.2872 43.7316 25.9343 44.1668 25.9343C44.602 25.9343 44.9549 26.2872 44.9549 26.7224Z",
    fill: "url(#paint20_radial_2429_487)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0832 29.7313C40.0832 30.2457 39.6662 30.6627 39.1519 30.6627C38.6375 30.6627 38.2205 30.2457 38.2205 29.7313C38.2205 29.217 38.6375 28.8 39.1519 28.8C39.6662 28.8 40.0832 29.217 40.0832 29.7313Z",
    fill: "url(#paint21_radial_2429_487)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0832 35.3194C40.0832 35.8338 39.6662 36.2507 39.1519 36.2507C38.6375 36.2507 38.2205 35.8338 38.2205 35.3194C38.2205 34.805 38.6375 34.3881 39.1519 34.3881C39.6662 34.3881 40.0832 34.805 40.0832 35.3194Z",
    fill: "url(#paint22_radial_2429_487)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3489 41.194C33.3489 41.6293 32.9961 41.9821 32.5608 41.9821C32.1256 41.9821 31.7728 41.6293 31.7728 41.194C31.7728 40.7588 32.1256 40.406 32.5608 40.406C32.9961 40.406 33.3489 40.7588 33.3489 41.194Z",
    fill: "url(#paint23_radial_2429_487)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1996 42.0537C31.1996 42.5681 30.7827 42.9851 30.2683 42.9851C29.7539 42.9851 29.3369 42.5681 29.3369 42.0537C29.3369 41.5394 29.7539 41.1224 30.2683 41.1224C30.7827 41.1224 31.1996 41.5394 31.1996 42.0537Z",
    fill: "url(#paint24_radial_2429_487)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9399 17.9821C39.9399 18.4965 39.523 18.9134 39.0086 18.9134C38.4942 18.9134 38.0772 18.4965 38.0772 17.9821C38.0772 17.4677 38.4942 17.0507 39.0086 17.0507C39.523 17.0507 39.9399 17.4677 39.9399 17.9821Z",
    fill: "url(#paint25_radial_2429_487)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0563 5.6597C31.0563 6.17407 30.6394 6.59104 30.125 6.59104C29.6106 6.59104 29.1937 6.17407 29.1937 5.6597C29.1937 5.14533 29.6106 4.72836 30.125 4.72836C30.6394 4.72836 31.0563 5.14533 31.0563 5.6597Z",
    fill: "url(#paint26_radial_2429_487)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4444 6.23284C17.4444 6.58894 17.1557 6.87761 16.7996 6.87761C16.4435 6.87761 16.1549 6.58894 16.1549 6.23284C16.1549 5.87674 16.4435 5.58806 16.7996 5.58806C17.1557 5.58806 17.4444 5.87674 17.4444 6.23284Z",
    fill: "url(#paint27_radial_2429_487)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0623 6.23284C33.0623 6.58894 32.7736 6.87761 32.4175 6.87761C32.0614 6.87761 31.7728 6.58894 31.7728 6.23284C31.7728 5.87674 32.0614 5.58806 32.4175 5.58806C32.7736 5.58806 33.0623 5.87674 33.0623 6.23284Z",
    fill: "url(#paint28_radial_2429_487)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9399 12.609C39.9399 13.0838 39.555 13.4687 39.0802 13.4687C38.6054 13.4687 38.2205 13.0838 38.2205 12.609C38.2205 12.1342 38.6054 11.7493 39.0802 11.7493C39.555 11.7493 39.9399 12.1342 39.9399 12.609Z",
    fill: "url(#paint29_radial_2429_487)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1638 2.36418C19.1638 2.72028 18.8751 3.00896 18.519 3.00896C18.1629 3.00896 17.8743 2.72028 17.8743 2.36418C17.8743 2.00808 18.1629 1.7194 18.519 1.7194C18.8751 1.7194 19.1638 2.00808 19.1638 2.36418Z",
    fill: "url(#paint30_radial_2429_487)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4862 2.36418C31.4862 2.72028 31.1975 3.00896 30.8414 3.00896C30.4853 3.00896 30.1967 2.72028 30.1967 2.36418C30.1967 2.00808 30.4853 1.7194 30.8414 1.7194C31.1975 1.7194 31.4862 2.00808 31.4862 2.36418Z",
    fill: "url(#paint31_radial_2429_487)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7369 5.6597C19.7369 6.17407 19.32 6.59104 18.8056 6.59104C18.2912 6.59104 17.8743 6.17407 17.8743 5.6597C17.8743 5.14533 18.2912 4.72836 18.8056 4.72836C19.32 4.72836 19.7369 5.14533 19.7369 5.6597Z",
    fill: "url(#paint32_radial_2429_487)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4683 36.1791C25.4683 36.6935 25.0513 37.1104 24.5369 37.1104C24.0226 37.1104 23.6056 36.6935 23.6056 36.1791C23.6056 35.6647 24.0226 35.2478 24.5369 35.2478C25.0513 35.2478 25.4683 35.6647 25.4683 36.1791Z",
    fill: "url(#paint33_radial_2429_487)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4683 39.1881C25.4683 39.7024 25.0513 40.1194 24.5369 40.1194C24.0226 40.1194 23.6056 39.7024 23.6056 39.1881C23.6056 38.6737 24.0226 38.2567 24.5369 38.2567C25.0513 38.2567 25.4683 38.6737 25.4683 39.1881Z",
    fill: "url(#paint34_radial_2429_487)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8802 42.197C19.8802 42.7114 19.4633 43.1284 18.9489 43.1284C18.4345 43.1284 18.0175 42.7114 18.0175 42.197C18.0175 41.6826 18.4345 41.2657 18.9489 41.2657C19.4633 41.2657 19.8802 41.6826 19.8802 42.197Z",
    fill: "url(#paint35_radial_2429_487)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3011 41.194C17.3011 41.5501 17.0124 41.8388 16.6563 41.8388C16.3002 41.8388 16.0116 41.5501 16.0116 41.194C16.0116 40.8379 16.3002 40.5493 16.6563 40.5493C17.0124 40.5493 17.3011 40.8379 17.3011 41.194Z",
    fill: "url(#paint36_radial_2429_487)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5758 36.7522C13.5758 37.1083 13.2871 37.397 12.931 37.397C12.5749 37.397 12.2862 37.1083 12.2862 36.7522C12.2862 36.3961 12.5749 36.1075 12.931 36.1075C13.2871 36.1075 13.5758 36.3961 13.5758 36.7522Z",
    fill: "url(#paint37_radial_2429_487)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83844 26.7224C5.83844 27.0785 5.54976 27.3672 5.19366 27.3672C4.83756 27.3672 4.54889 27.0785 4.54889 26.7224C4.54889 26.3663 4.83756 26.0776 5.19366 26.0776C5.54976 26.0776 5.83844 26.3663 5.83844 26.7224Z",
    fill: "url(#paint38_radial_2429_487)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41157 23.8567C6.41157 24.2128 6.1229 24.5015 5.7668 24.5015C5.4107 24.5015 5.12202 24.2128 5.12202 23.8567C5.12202 23.5006 5.4107 23.2119 5.7668 23.2119C6.1229 23.2119 6.41157 23.5006 6.41157 23.8567Z",
    fill: "url(#paint39_radial_2429_487)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69516 20.991C5.69516 21.3471 5.40648 21.6358 5.05038 21.6358C4.69428 21.6358 4.4056 21.3471 4.4056 20.991C4.4056 20.6349 4.69428 20.3463 5.05038 20.3463C5.40648 20.3463 5.69516 20.6349 5.69516 20.991Z",
    fill: "url(#paint40_radial_2429_487)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9966 12.6806C10.9966 13.195 10.5797 13.6119 10.0653 13.6119C9.55094 13.6119 9.13396 13.195 9.13396 12.6806C9.13396 12.1662 9.55094 11.7493 10.0653 11.7493C10.5797 11.7493 10.9966 12.1662 10.9966 12.6806Z",
    fill: "url(#paint41_radial_2429_487)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1399 18.197C11.1399 18.7509 10.6909 19.2 10.1369 19.2C9.58301 19.2 9.13396 18.7509 9.13396 18.197C9.13396 17.6431 9.58301 17.194 10.1369 17.194C10.6909 17.194 11.1399 17.6431 11.1399 18.197Z",
    fill: "url(#paint42_radial_2429_487)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8683 15.6179C15.8683 16.4092 15.2268 17.0507 14.4355 17.0507C13.6441 17.0507 13.0026 16.4092 13.0026 15.6179C13.0026 14.8266 13.6441 14.1851 14.4355 14.1851C15.2268 14.1851 15.8683 14.8266 15.8683 15.6179Z",
    fill: "url(#paint43_radial_2429_487)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1399 35.2478C11.1399 35.8017 10.6909 36.2507 10.1369 36.2507C9.58301 36.2507 9.13396 35.8017 9.13396 35.2478C9.13396 34.6938 9.58301 34.2448 10.1369 34.2448C10.6909 34.2448 11.1399 34.6938 11.1399 35.2478Z",
    fill: "url(#paint44_radial_2429_487)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1399 29.9463C11.1399 30.5002 10.6909 30.9493 10.1369 30.9493C9.58301 30.9493 9.13396 30.5002 9.13396 29.9463C9.13396 29.3923 9.58301 28.9433 10.1369 28.9433C10.6909 28.9433 11.1399 29.3923 11.1399 29.9463Z",
    fill: "url(#paint45_radial_2429_487)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6563 5.6597C40.6563 6.80713 39.7262 7.73731 38.5787 7.73731C37.4313 7.73731 36.5011 6.80713 36.5011 5.6597C36.5011 4.51227 37.4313 3.58209 38.5787 3.58209C39.7262 3.58209 40.6563 4.51227 40.6563 5.6597Z",
    fill: "url(#paint46_radial_2429_487)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3907 15.403C47.3907 16.5504 46.4605 17.4806 45.3131 17.4806C44.1656 17.4806 43.2355 16.5504 43.2355 15.403C43.2355 14.2556 44.1656 13.3254 45.3131 13.3254C46.4605 13.3254 47.3907 14.2556 47.3907 15.403Z",
    fill: "url(#paint47_radial_2429_487)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3937 23.8567C48.3937 24.6085 47.7842 25.2179 47.0325 25.2179C46.2807 25.2179 45.6713 24.6085 45.6713 23.8567C45.6713 23.1049 46.2807 22.4955 47.0325 22.4955C47.7842 22.4955 48.3937 23.1049 48.3937 23.8567Z",
    fill: "url(#paint48_radial_2429_487)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68918 23.8567C3.68918 24.6085 3.07976 25.2179 2.32799 25.2179C1.57622 25.2179 0.966797 24.6085 0.966797 23.8567C0.966797 23.1049 1.57622 22.4955 2.32799 22.4955C3.07976 22.4955 3.68918 23.1049 3.68918 23.8567Z",
    fill: "url(#paint49_radial_2429_487)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4265 23.5701C11.4265 24.4802 10.6888 25.2179 9.77874 25.2179C8.8687 25.2179 8.13098 24.4802 8.13098 23.5701C8.13098 22.6601 8.8687 21.9224 9.77874 21.9224C10.6888 21.9224 11.4265 22.6601 11.4265 23.5701Z",
    fill: "url(#paint50_radial_2429_487)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2592 19.6238C18.8822 18.4222 19.7501 17.5098 20.9072 16.8422C22.0644 16.1969 23.4218 15.8631 24.9795 15.8631C26.1811 15.8631 27.2715 16.1079 28.2506 16.5752C29.2075 17.0648 29.9863 17.7324 30.5871 18.578C31.1657 19.4458 31.5217 20.4472 31.6552 21.5598H28.3174C28.1171 20.6697 27.7165 19.9799 27.0935 19.4681C26.4704 18.9562 25.7138 18.6892 24.8014 18.6892C23.5553 18.6892 22.5539 19.1565 21.8418 20.0911C21.1075 21.0257 20.7515 22.2719 20.7515 23.7851C20.7515 25.2982 21.1075 26.5444 21.8418 27.479C22.5539 28.4136 23.5553 28.8809 24.8014 28.8809C25.7138 28.8809 26.4704 28.6361 27.0935 28.1243C27.7165 27.6125 28.1171 26.9004 28.3174 26.0103H31.6552C31.5217 27.1452 31.1657 28.1466 30.5871 28.9922C29.9863 29.86 29.2075 30.5276 28.2506 30.9949C27.2715 31.4845 26.1811 31.707 24.9795 31.707C23.4218 31.707 22.0644 31.3955 20.9072 30.7279C19.7501 30.0826 18.8822 29.1702 18.2592 27.9686C17.6361 26.7669 17.3468 25.3873 17.3468 23.7851C17.3468 22.2051 17.6361 20.8255 18.2592 19.6238Z",
    fill: "#040009"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.9894 0.597945) rotate(83.1542) scale(47.7424 47.1887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398315,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2429_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-28.5496 -2.43582) rotate(2.38173) scale(81.0252 80.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957757,
    stopColor: "#5638FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752766,
    stopColor: "#ED499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864635,
    stopColor: "#F7AC32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsPlanetLogo);
export default __webpack_public_path__ + "static/media/campaigns-planet-logo.27fd05e356c6fdc951aa2b95e1f8e83a.svg";
export { ForwardRef as ReactComponent };